import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { BuildingApiService } from '../services/api/building-api.service';
import { map } from 'rxjs/operators';

@Injectable()
export class ResidentPatchResolver implements Resolve<Observable<number>> {
    constructor(
        private buildingApi: BuildingApiService,
    ) {}

    /**
     * Resolves number of resident patches
     *
     * for building ID
     */
    resolve(route: ActivatedRouteSnapshot): Observable<number> {
        const params = {
            'per-page': 1,
            'page': 1
        };

        return this.buildingApi.getResidentPatchList(params).pipe(
            map(result => result.total)
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/resolvers/resitent-patch.resolver.ts